import { render, staticRenderFns } from "./YioksTip.vue?vue&type=template&id=8a580f76&scoped=true&"
import script from "./YioksTip.vue?vue&type=script&lang=js&"
export * from "./YioksTip.vue?vue&type=script&lang=js&"
import style0 from "./YioksTip.vue?vue&type=style&index=0&id=8a580f76&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a580f76",
  null
  
)

export default component.exports